// Provalo Gourmet-Naïf — translations
// IT (default), EN, ES, FR, DE — madrelingua, tono ristorazione cinematografica

export const translations = {
  it: {
    topbar: { thursdayOnly: "Solo il giovedì sera", addressHint: "10 min dall'aeroporto" },
    hero: {
      eyebrow: "— Gourmet-Naïf · Sezione del giovedì",
      title: ["Ogni giovedì, da Provalo,", "si apre", "qualcosa di diverso."],
      subtitle_a: "Una sezione speciale del menù dedicata agli Spiedi più ricercati, alle creazioni del ",
      subtitle_b: "Provalo-Lab",
      subtitle_c: " e a tutto ciò che nasce per sorprendere.",
      micro: "Puoi vivere il tuo normale Provalo di sempre. Oppure lasciarti tentare da qualcosa che esiste solo il giovedì.",
      ctaReserve: "Prenota il tuo giovedì",
      ctaDiscover: "Scopri il Gourmet-Naïf",
      scroll: "Scorri",
    },
    intro: {
      eyebrow: "— Cos'è il Gourmet-Naïf",
      title_a: "Non una serata a tema.",
      title_b: "Una sezione",
      title_c: " che si accende.",
      p1_a: "Ogni giovedì sera, nel menù di Provalo compare una sezione speciale: ",
      p1_b: "Gourmet-Naïf",
      p1_c: ".",
      p2: "Un luogo dove convivono ricerca, brace, idee nuove e Spiedi fuori dal normale. Nessun percorso obbligatorio. Nessuna formalità. Solo il piacere di scoprire qualcosa di diverso, al proprio ritmo.",
      menuBtn: "Apri il menù completo",
      menuHint: "Gourmet-Naïf e tutto il resto, in un unico menù.",
      quote: '"ricerca · brace · sorpresa"',
    },
    manifesto: {
      eyebrow: "— In 22 secondi",
      title_a: "Il ",
      title_b: "Gourmet-Naïf",
      title_c: ", raccontato come lo viviamo.",
      audioOn: "Attiva audio",
      caption: "Ventidue secondi. Tutto quello che il giovedì significa.",
    },
    lab: {
      eyebrow: "— Il Provalo-Lab",
      title_a: "Dove le idee",
      title_b: "diventano Spiedi.",
      p1_a: "Il ",
      p1_b: "Provalo-Lab",
      p1_c: " è il nostro spazio di ricerca e sviluppo gastronomico.",
      p2: "Qui nascono consistenze, contrasti, esperimenti e creazioni che richiedono mesi di prove prima di arrivare al tavolo.",
      pull_a: "Non per complicare il cibo.",
      pull_b: "Ma per renderlo memorabile.",
    },
    products: {
      labelPrefix: "Gourmet-Naïf · ",
      attimosphera: {
        name_a: "Attimo", name_b: "sphera", name_c: ".",
        tagline: "Un'esperienza sensoriale nata nel Provalo-Lab",
        p1: "Una piccola architettura commestibile: forma sferica, contrasti di temperatura, sospensione del tempo. Si ferma, si guarda, si morde.",
        p2: "Nasce da mesi di prove.",
        pull: "Una sfera, più attimi da ricordare.",
      },
      picanha: {
        name_a: "Picanha ", name_b: "&", name_c: " Pata Negra.",
        tagline: "Due carni nobili. Un solo Spiedo.",
        p1: "L'incontro tra il taglio brasiliano più carnale e il grasso di Pata Negra, lento, profondo, dolce.",
        p2: "Lo Spiedo che racconta come due tradizioni distanti possano abbracciarsi sulla stessa brace.",
      },
      filofumo: {
        name_a: "Filo di ", name_b: "Fumo", name_c: ".",
        tagline: "Una mini-porchetta reinterpretata allo Spiedo",
        p1: "Avvolgente, aromatica, sorprendente. La porchetta lascia il banco del paese e sale sullo Spiedo, con un filo di affumicatura che resta in bocca dopo l'ultimo morso.",
        p2: "Tradizione che si rimette in gioco. Senza chiedere permesso.",
      },
      salsiccia: {
        name_a: "Mix di Salsiccia ", name_b: "Messinese", name_c: ".",
        tagline: "La tradizione che continua a sorprendere",
        p1: "Due varianti, due caratteri, una sola origine. La Salsiccia di Messina raccontata in formati e impasti diversi, da condividere lentamente.",
        p2: "Il pezzo più conviviale del Gourmet-Naïf. Quello che riempie il tavolo di voci.",
      },
      whisky: {
        name_a: "Salsa al ", name_b: "Whisky", name_c: ".",
        tagline: "Non una salsa, ma un piccolo colpo di scena",
        p1: "Arriva al tavolo come un dettaglio. Resta nella memoria come una svolta.",
        p2: "Calda, ambrata, leggermente affumicata. Cambia il sapore dello Spiedo prima ancora che tu finisca il primo morso.",
        pull: "Un secondo prima sapevi cosa stavi mangiando. Un secondo dopo, non più.",
        ornament: '"qualcosa di liquido, ambrato, che cambia tutto al primo morso."',
      },
    },
    convivialita: {
      eyebrow: "— Convivialità",
      title_a: "Il bello succede ",
      title_b: "attorno al tavolo.",
      p1: "Il Gourmet-Naïf non nasce per mettere distanza.",
      p2: "Nasce per creare conversazioni, condivisione, curiosità e piccoli silenzi davanti a qualcosa che non ti aspettavi.",
    },
    filosofia: {
      eyebrow: "— La filosofia",
      title_a: "Gourmet,", title_a2: " perché c'è ricerca.",
      title_b: "Naïf,", title_b2: " perché resta umano.",
      pull_a: "Ci piace studiare il cibo.",
      pull_b: "Ma ci piace ancora di più vedere le persone divertirsi mentre lo mangiano.",
      p1: "Per questo il Gourmet-Naïf non vuole essere freddo, complicato o pretenzioso. Vuole essere scoperta, sorpresa e piacere condiviso.",
    },
    faq: {
      eyebrow: "— Domande dritte, risposte sincere",
      title_a: "Prima di prenotare,",
      title_b: "qualche dubbio?",
      q1: { q: "Devo prenotare anche se voglio solo il menù normale?",
        a1: "Sì. Il giovedì è una serata molto richiesta, anche per chi viene per il menù di sempre. Per evitare confusione, abbiamo due percorsi separati: uno per chi viene per il Gourmet-Naïf, uno per chi viene per il Provalo classico. Così sappiamo chi aspettarci, e voi trovate il posto pronto.",
        a2: "Poi, se quando passate vedete sfilare un'Attimosphera e cambiate idea, c'è tempo per ordinarla al tavolo.",
        cta: "Prenota per il menù normale" },
      q2: { q: "Posso ordinare il Gourmet-Naïf in un altro giorno della settimana?",
        short: "No.",
        a1: "Il Gourmet-Naïf esiste solo il giovedì sera. È una scelta — non un limite. Concentriamo lì la ricerca, la mise en place dedicata e le preparazioni speciali, perché ogni giovedì sia davvero diverso dagli altri.",
        a2: "Negli altri giorni, c'è tutto il Provalo che ami. E già basta." },
      q3: { q: "Avete opzioni vegetariane nel Gourmet-Naïf?",
        a1: "Nel Gourmet-Naïf no: la sezione è composta da quelle precise creazioni nate nel Provalo-Lab, e sono quelle.",
        a2_pre: "Però il giovedì ", a2_em: "tutto il menù Provalo", a2_post: " è comunque attivo, e dentro ci sono parecchi Spiedi e creazioni vegetariane: funghi, formaggi, verdure, frutta. Si può tranquillamente comporre una serata vegetariana piena." },
    },
    ctafinal: {
      eyebrow: "— Il tuo giovedì",
      title_a: "Il giovedì da Provalo ",
      title_b: "succede questo.",
      pull_a: "Puoi venire per gli Spiedi che ami da sempre.",
      pull_b: "Oppure scoprire qualcosa che esiste solo quella sera.",
      ctaReserve: "Prenota il tuo giovedì",
      ctaMenu: "Guarda il menù Gourmet-Naïf",
    },
    recensioni: {
      eyebrow: "— Recensioni autentiche",
      title_a: "Non chiederlo a noi.", title_b: "Chiedilo", title_c: " a chi era al tavolo.",
      desc: "Quasi mille recensioni reali. Una media che parla da sola. Non scegliamo cosa farti leggere: c'è tutto, esattamente come è stato scritto.",
      stat1_v: ">", stat1_v_big: "900", stat1_label: "Recensioni", stat1_sub: "Su TripAdvisor — tutte verificate",
      stat2_label: "Media TripAdvisor", stat2_sub: "Media generale 4,7 includendo Google",
      stat3_v: "Top 10%", stat3_label: "Travelers' Choice 2025", stat3_sub: "Tra i migliori al mondo, secondo i viaggiatori",
      stat4_v: "1°", stat4_label: "A Fiumicino", stat4_sub: "Nella classifica TripAdvisor della città",
      ctaTA: "Leggi tutte le recensioni su TripAdvisor",
      ctaCaption: "Le ultime, le più sincere, le più dure. Sono tutte lì.",
    },
    navigatore: {
      eyebrow: "— Vieni a trovarci",
      title_a: "A ", title_b: "dieci minuti", title_c: " dall'aeroporto di Fiumicino.",
      mapOpen: "Apri in Google Maps ↗",
      pin: "Provalo",
      hoursTitle: "Tutti i giorni:",
      hours1: "19:30 — 22:30",
      hoursWE: "",
      hours2: "",
      monClosed: "",
      ctaNav: "Portami da Provalo",
      ctaNavHint: "Apre il tuo navigatore con il percorso già impostato.",
      ctaWA: "Scrivici su WhatsApp",
      groupTitle: "Siete più di dodici?",
      groupBody: "Tavolate da 13 in su si prenotano direttamente al telefono. Chiamaci e organizziamo lo Spiedo come piace a voi.",
    },
    footer: {
      claim_a: "Solo il giovedì sera.",
      claim_b: "Da Provalo Spiedinificio.",
      tagline: "Gourmet-Naïf · Una sezione del menù",
      rights: "Tutti i diritti riservati",
    },
    sticky: { eyebrow: "Solo il giovedì", line: "Prenota la tua sera", btn: "Prenota" },
    menuIntermezzo: {
      title_a: "Oltre al Gourmet-Naïf, ecco tutto il",
      title_b: "menù completo.",
      btn: "Menù completo",
    },
    social: {
      followEyebrow: "— Seguici",
      followTitle_a: "Le nostre",
      followTitle_b: "tracce quotidiane.",
      channelEyebrow: "— Il nostro canale WhatsApp",
      channelTitle_a: "Dietro la",
      channelTitle_b: "brace.",
      channelJoin: "Unisciti al canale",
      channelSub: "Anteprime, novità & rituali dal Lab",
    },
    modal: {
      eyebrow: "— Prenota",
      title_a: "Il tuo giovedì ", title_b: "da Provalo.",
      sub: "Lascia un contatto: ti confermiamo via telefono.",
      l_name: "Nome e cognome", ph_name: "Mario Rossi",
      l_phone: "Telefono", ph_phone: "+39 333 …",
      l_people: "Persone",
      l_thu: "Quale giovedì",
      l_note: "Note (facoltativo)", ph_note: "Qualcosa che dovremmo sapere?",
      err: "Inserisci nome e telefono validi.",
      genErr: "Qualcosa è andato storto. Riprova o usa il pulsante esterno.",
      submit: "Conferma prenotazione", submitting: "Invio in corso…",
      portalHint: "Preferisci il sistema ufficiale?", portalLink: "Apri il portale prenotazioni",
      successTitle_a: "Ci vediamo ", successTitle_b: "giovedì.",
      successBody: "Abbiamo ricevuto la tua richiesta. Ti contatteremo a breve per confermare.",
      close: "Chiudi",
    },
  },
  en: {
    topbar: { thursdayOnly: "Only on Thursday nights", addressHint: "10 min from the airport" },
    hero: {
      eyebrow: "— Gourmet-Naïf · The Thursday section",
      title: ["Every Thursday, at Provalo,", "something different", "opens up."],
      subtitle_a: "A dedicated section of the menu, built around our most refined skewers, the creations of the ",
      subtitle_b: "Provalo-Lab",
      subtitle_c: " and everything we make to surprise you.",
      micro: "You can enjoy your usual Provalo evening. Or let yourself be tempted by something that exists only on Thursday.",
      ctaReserve: "Book your Thursday",
      ctaDiscover: "Discover the Gourmet-Naïf",
      scroll: "Scroll",
    },
    intro: {
      eyebrow: "— What the Gourmet-Naïf is",
      title_a: "Not a themed night.",
      title_b: "A section",
      title_c: " that comes to life.",
      p1_a: "Every Thursday evening, a special section appears on the Provalo menu: ",
      p1_b: "Gourmet-Naïf",
      p1_c: ".",
      p2: "A place where research, embers, new ideas and out-of-the-ordinary skewers meet. No tasting menu obligation. No formality. Just the pleasure of discovering something different, at your own pace.",
      menuBtn: "Open the full menu",
      menuHint: "Gourmet-Naïf and everything else, in one menu.",
      quote: '"research · embers · surprise"',
    },
    manifesto: {
      eyebrow: "— In 22 seconds",
      title_a: "The ",
      title_b: "Gourmet-Naïf",
      title_c: ", the way we actually live it.",
      audioOn: "Turn on audio",
      caption: "Twenty-two seconds. Everything Thursday means.",
    },
    lab: {
      eyebrow: "— The Provalo-Lab",
      title_a: "Where ideas",
      title_b: "become skewers.",
      p1_a: "The ",
      p1_b: "Provalo-Lab",
      p1_c: " is our space for culinary research and development.",
      p2: "This is where textures, contrasts, experiments and creations are born — each one requiring months of trials before reaching the table.",
      pull_a: "Not to make food more complicated.",
      pull_b: "But to make it unforgettable.",
    },
    products: {
      labelPrefix: "Gourmet-Naïf · ",
      attimosphera: {
        name_a: "Attimo", name_b: "sphera", name_c: ".",
        tagline: "A sensory experience born in the Provalo-Lab",
        p1: "A tiny edible architecture: spherical shape, temperature contrasts, suspended time. You stop, you look, you bite.",
        p2: "Born from months of trials.",
        pull: "One sphere, several moments worth keeping.",
      },
      picanha: {
        name_a: "Picanha ", name_b: "&", name_c: " Pata Negra.",
        tagline: "Two noble cuts. One single skewer.",
        p1: "The meeting between the most carnal Brazilian cut and the deep, slow, sweet fat of Pata Negra.",
        p2: "The skewer that shows how two distant traditions can embrace on the same embers.",
      },
      filofumo: {
        name_a: "A Thread of ", name_b: "Smoke", name_c: ".",
        tagline: "A mini-porchetta reimagined on the skewer",
        p1: "Enveloping, aromatic, surprising. Porchetta leaves the village stall and climbs onto the skewer, with a thread of smoke that lingers after the last bite.",
        p2: "Tradition stepping back into the game. Without asking for permission.",
      },
      salsiccia: {
        name_a: "Messina Sausage ", name_b: "Mix", name_c: ".",
        tagline: "Tradition that keeps surprising",
        p1: "Two versions, two characters, one single origin. Messina-style sausage told through different cuts and blends, made to share slowly.",
        p2: "The most convivial piece of the Gourmet-Naïf. The one that fills the table with voices.",
      },
      whisky: {
        name_a: "Whisky ", name_b: "Sauce", name_c: ".",
        tagline: "Not a sauce. A small plot twist.",
        p1: "It arrives at the table like a detail. It stays in your memory like a turning point.",
        p2: "Warm, amber, gently smoky. It changes the flavour of the skewer before you've even finished your first bite.",
        pull: "A second before, you knew what you were eating. A second later, you didn't.",
        ornament: '"something liquid, amber, that changes everything at the first bite."',
      },
    },
    convivialita: {
      eyebrow: "— Conviviality",
      title_a: "The good things happen ",
      title_b: "around the table.",
      p1: "The Gourmet-Naïf isn't built to put distance between people.",
      p2: "It's built to spark conversations, sharing, curiosity — and small silences in front of something you didn't see coming.",
    },
    filosofia: {
      eyebrow: "— The philosophy",
      title_a: "Gourmet,", title_a2: " because there's research.",
      title_b: "Naïf,", title_b2: " because it stays human.",
      pull_a: "We love studying food.",
      pull_b: "But we love even more watching people enjoy themselves while eating it.",
      p1: "That's why the Gourmet-Naïf doesn't want to be cold, complicated or pretentious. It wants to be discovery, surprise and shared pleasure.",
    },
    faq: {
      eyebrow: "— Straight questions, honest answers",
      title_a: "Before you book,",
      title_b: "anything on your mind?",
      q1: { q: "Do I need to book even if I only want the regular menu?",
        a1: "Yes. Thursday is a very popular night, including for guests coming for the usual menu. To avoid confusion, we have two separate booking flows: one for those coming for the Gourmet-Naïf, and one for those coming for the classic Provalo. That way we know who to expect, and your table is ready when you arrive.",
        a2: "And of course, if you see an Attimosphera passing by and change your mind, there's still time to order it at the table.",
        cta: "Book for the regular menu" },
      q2: { q: "Can I order the Gourmet-Naïf on another day of the week?",
        short: "No.",
        a1: "The Gourmet-Naïf only exists on Thursday evenings. It's a choice — not a limit. That's where we focus our research, our dedicated mise en place and the special preparations, so every Thursday truly feels different.",
        a2: "On the other days, the whole Provalo you love is still there. And that's plenty." },
      q3: { q: "Are there vegetarian options in the Gourmet-Naïf?",
        a1: "Not within the Gourmet-Naïf itself: the section is made of those specific creations born in the Provalo-Lab, and those alone.",
        a2_pre: "However, on Thursdays ", a2_em: "the whole Provalo menu", a2_post: " is also active, and inside there are plenty of vegetarian skewers and creations: mushrooms, cheeses, vegetables, fruit. You can easily put together a fully vegetarian evening." },
    },
    ctafinal: {
      eyebrow: "— Your Thursday",
      title_a: "On Thursdays at Provalo, ",
      title_b: "this is what happens.",
      pull_a: "You can come for the skewers you've always loved.",
      pull_b: "Or discover something that only exists that night.",
      ctaReserve: "Book your Thursday",
      ctaMenu: "View the Gourmet-Naïf menu",
    },
    recensioni: {
      eyebrow: "— Authentic reviews",
      title_a: "Don't take our word for it.", title_b: "Ask", title_c: " those who sat at our table.",
      desc: "Nearly a thousand real reviews. An average that speaks for itself. We don't curate what you read: it's all there, exactly as it was written.",
      stat1_v: ">", stat1_v_big: "900", stat1_label: "Reviews", stat1_sub: "On TripAdvisor — all verified",
      stat2_label: "TripAdvisor rating", stat2_sub: "Overall 4.7 including Google",
      stat3_v: "Top 10%", stat3_label: "Travelers' Choice 2025", stat3_sub: "Among the world's best, according to travellers",
      stat4_v: "1st", stat4_label: "In Fiumicino", stat4_sub: "On TripAdvisor's local ranking",
      ctaTA: "Read all reviews on TripAdvisor",
      ctaCaption: "The latest, the most sincere, the harshest. They're all there.",
    },
    navigatore: {
      eyebrow: "— Come and visit us",
      title_a: "Just ", title_b: "ten minutes", title_c: " from Fiumicino airport.",
      mapOpen: "Open in Google Maps ↗",
      pin: "Provalo",
      hoursTitle: "Every day:",
      hours1: "7:30pm — 10:30pm",
      hoursWE: "",
      hours2: "",
      monClosed: "",
      ctaNav: "Take me to Provalo",
      ctaNavHint: "Opens your favourite navigation app with the route ready.",
      ctaWA: "Message us on WhatsApp",
      groupTitle: "More than twelve of you?",
      groupBody: "Groups of 13 or more are booked directly over the phone. Give us a call and we'll set up the skewers exactly the way you like them.",
    },
    footer: {
      claim_a: "Only on Thursday nights.",
      claim_b: "At Provalo Spiedinificio.",
      tagline: "Gourmet-Naïf · A menu section",
      rights: "All rights reserved",
    },
    sticky: { eyebrow: "Only on Thursday", line: "Book your evening", btn: "Book" },
    menuIntermezzo: {
      title_a: "Beyond the Gourmet-Naïf, here is the",
      title_b: "full menu.",
      btn: "Full menu",
    },
    social: {
      followEyebrow: "— Follow us",
      followTitle_a: "Our",
      followTitle_b: "everyday traces.",
      channelEyebrow: "— Our WhatsApp channel",
      channelTitle_a: "Behind the",
      channelTitle_b: "embers.",
      channelJoin: "Join the channel",
      channelSub: "Previews, news & rituals from the Lab",
    },
    modal: {
      eyebrow: "— Booking",
      title_a: "Your Thursday ", title_b: "at Provalo.",
      sub: "Leave us your details: we'll confirm by phone.",
      l_name: "Full name", ph_name: "John Smith",
      l_phone: "Phone", ph_phone: "+39 333 …",
      l_people: "Guests",
      l_thu: "Which Thursday",
      l_note: "Notes (optional)", ph_note: "Anything we should know?",
      err: "Please enter a valid name and phone.",
      genErr: "Something went wrong. Please try again or use the external button.",
      submit: "Confirm booking", submitting: "Sending…",
      portalHint: "Prefer the official system?", portalLink: "Open the booking portal",
      successTitle_a: "See you ", successTitle_b: "Thursday.",
      successBody: "We've received your request. We'll contact you shortly to confirm.",
      close: "Close",
    },
  },
  es: {
    topbar: { thursdayOnly: "Sólo los jueves por la noche", addressHint: "10 min del aeropuerto" },
    hero: {
      eyebrow: "— Gourmet-Naïf · La sección del jueves",
      title: ["Cada jueves, en Provalo,", "se abre", "algo distinto."],
      subtitle_a: "Una sección especial del menú, dedicada a los pinchos más cuidados, a las creaciones del ",
      subtitle_b: "Provalo-Lab",
      subtitle_c: " y a todo lo que nace para sorprender.",
      micro: "Puedes vivir tu Provalo de siempre. O dejarte tentar por algo que existe sólo el jueves.",
      ctaReserve: "Reserva tu jueves",
      ctaDiscover: "Descubre el Gourmet-Naïf",
      scroll: "Desplázate",
    },
    intro: {
      eyebrow: "— Qué es el Gourmet-Naïf",
      title_a: "No es una noche temática.",
      title_b: "Es una sección",
      title_c: " que se enciende.",
      p1_a: "Cada jueves por la noche, en la carta de Provalo aparece una sección especial: ",
      p1_b: "Gourmet-Naïf",
      p1_c: ".",
      p2: "Un espacio donde conviven investigación, brasa, ideas nuevas y pinchos fuera de lo común. Sin menú degustación obligatorio. Sin formalidades. Sólo el placer de descubrir algo distinto, a tu propio ritmo.",
      menuBtn: "Abrir la carta completa",
      menuHint: "Gourmet-Naïf y todo lo demás, en una sola carta.",
      quote: '"investigación · brasa · sorpresa"',
    },
    manifesto: {
      eyebrow: "— En 22 segundos",
      title_a: "El ",
      title_b: "Gourmet-Naïf",
      title_c: ", contado como lo vivimos.",
      audioOn: "Activar audio",
      caption: "Veintidós segundos. Todo lo que significa un jueves.",
    },
    lab: {
      eyebrow: "— El Provalo-Lab",
      title_a: "Donde las ideas",
      title_b: "se vuelven pinchos.",
      p1_a: "El ",
      p1_b: "Provalo-Lab",
      p1_c: " es nuestro espacio de investigación y desarrollo gastronómico.",
      p2: "Aquí nacen texturas, contrastes, experimentos y creaciones que requieren meses de pruebas antes de llegar a la mesa.",
      pull_a: "No para complicar la comida.",
      pull_b: "Sino para hacerla inolvidable.",
    },
    products: {
      labelPrefix: "Gourmet-Naïf · ",
      attimosphera: {
        name_a: "Attimo", name_b: "sphera", name_c: ".",
        tagline: "Una experiencia sensorial nacida en el Provalo-Lab",
        p1: "Una pequeña arquitectura comestible: forma esférica, contrastes de temperatura, tiempo suspendido. Te detienes, lo miras, lo muerdes.",
        p2: "Nace de meses de pruebas.",
        pull: "Una esfera, varios instantes para recordar.",
      },
      picanha: {
        name_a: "Picanha ", name_b: "&", name_c: " Pata Negra.",
        tagline: "Dos carnes nobles. Un solo pincho.",
        p1: "El encuentro entre el corte brasileño más carnal y la grasa de Pata Negra: lenta, profunda, dulce.",
        p2: "El pincho que cuenta cómo dos tradiciones lejanas pueden abrazarse sobre las mismas brasas.",
      },
      filofumo: {
        name_a: "Hilo de ", name_b: "Humo", name_c: ".",
        tagline: "Una mini-porchetta reinterpretada en pincho",
        p1: "Envolvente, aromática, sorprendente. La porchetta deja el puesto del pueblo y sube al pincho, con un hilo de ahumado que permanece tras el último mordisco.",
        p2: "La tradición que vuelve a jugar. Sin pedir permiso.",
      },
      salsiccia: {
        name_a: "Mix de Salchicha ", name_b: "Mesinesa", name_c: ".",
        tagline: "La tradición que sigue sorprendiendo",
        p1: "Dos variantes, dos caracteres, un solo origen. La salchicha de Mesina contada en formatos y mezclas distintas, para compartir despacio.",
        p2: "La pieza más convivial del Gourmet-Naïf. La que llena la mesa de voces.",
      },
      whisky: {
        name_a: "Salsa al ", name_b: "Whisky", name_c: ".",
        tagline: "No es una salsa. Es un pequeño giro de guion.",
        p1: "Llega a la mesa como un detalle. Se queda en la memoria como un punto de inflexión.",
        p2: "Cálida, ambarina, ligeramente ahumada. Cambia el sabor del pincho antes de que termines el primer bocado.",
        pull: "Un segundo antes sabías lo que estabas comiendo. Un segundo después, ya no.",
        ornament: '"algo líquido, ámbar, que lo cambia todo al primer mordisco."',
      },
    },
    convivialita: {
      eyebrow: "— Convivialidad",
      title_a: "Lo bueno ocurre ",
      title_b: "alrededor de la mesa.",
      p1: "El Gourmet-Naïf no nace para poner distancia.",
      p2: "Nace para crear conversaciones, complicidad, curiosidad y pequeños silencios delante de algo que no te esperabas.",
    },
    filosofia: {
      eyebrow: "— La filosofía",
      title_a: "Gourmet,", title_a2: " porque hay investigación.",
      title_b: "Naïf,", title_b2: " porque sigue siendo humano.",
      pull_a: "Nos gusta estudiar la comida.",
      pull_b: "Pero nos gusta aún más ver a la gente disfrutarla.",
      p1: "Por eso el Gourmet-Naïf no quiere ser frío, complicado ni pretencioso. Quiere ser descubrimiento, sorpresa y placer compartido.",
    },
    faq: {
      eyebrow: "— Preguntas directas, respuestas sinceras",
      title_a: "Antes de reservar,",
      title_b: "¿alguna duda?",
      q1: { q: "¿Tengo que reservar incluso si sólo quiero la carta normal?",
        a1: "Sí. El jueves es una noche muy solicitada, también para quienes vienen por la carta de siempre. Para evitar confusiones, tenemos dos reservas separadas: una para quienes vienen por el Gourmet-Naïf y otra para quienes vienen por el Provalo clásico. Así sabemos a quién esperar y vosotros encontráis la mesa lista.",
        a2: "Después, si al pasar veis desfilar una Attimosphera y cambiáis de idea, todavía hay tiempo para pedirla en la mesa.",
        cta: "Reservar para la carta normal" },
      q2: { q: "¿Puedo pedir el Gourmet-Naïf otro día de la semana?",
        short: "No.",
        a1: "El Gourmet-Naïf existe sólo el jueves por la noche. Es una elección — no una limitación. Es allí donde concentramos la investigación, la mise en place dedicada y las elaboraciones especiales, para que cada jueves sea de verdad distinto.",
        a2: "Los demás días, sigue todo el Provalo que amas. Y ya es más que suficiente." },
      q3: { q: "¿Hay opciones vegetarianas en el Gourmet-Naïf?",
        a1: "Dentro del Gourmet-Naïf no: la sección está formada por esas creaciones concretas nacidas en el Provalo-Lab, y son ésas.",
        a2_pre: "Pero el jueves ", a2_em: "toda la carta de Provalo", a2_post: " está activa, y dentro hay bastantes pinchos y creaciones vegetarianas: setas, quesos, verduras, fruta. Se puede componer perfectamente una velada vegetariana completa." },
    },
    ctafinal: {
      eyebrow: "— Tu jueves",
      title_a: "Los jueves en Provalo ",
      title_b: "pasa esto.",
      pull_a: "Puedes venir por los pinchos que llevas amando siempre.",
      pull_b: "O descubrir algo que sólo existe esa noche.",
      ctaReserve: "Reserva tu jueves",
      ctaMenu: "Ver la carta Gourmet-Naïf",
    },
    recensioni: {
      eyebrow: "— Reseñas reales",
      title_a: "No nos lo preguntes a nosotros.", title_b: "Pregúntaselo", title_c: " a quien estuvo en la mesa.",
      desc: "Casi mil reseñas reales. Una media que habla sola. No elegimos qué te toca leer: está todo, tal como fue escrito.",
      stat1_v: ">", stat1_v_big: "900", stat1_label: "Reseñas", stat1_sub: "En TripAdvisor — todas verificadas",
      stat2_label: "Media TripAdvisor", stat2_sub: "Media general 4,7 incluyendo Google",
      stat3_v: "Top 10%", stat3_label: "Travelers' Choice 2025", stat3_sub: "Entre los mejores del mundo, según los viajeros",
      stat4_v: "1°", stat4_label: "En Fiumicino", stat4_sub: "En la clasificación TripAdvisor de la ciudad",
      ctaTA: "Lee todas las reseñas en TripAdvisor",
      ctaCaption: "Las últimas, las más sinceras, las más duras. Están todas allí.",
    },
    navigatore: {
      eyebrow: "— Ven a visitarnos",
      title_a: "A ", title_b: "diez minutos", title_c: " del aeropuerto de Fiumicino.",
      mapOpen: "Abrir en Google Maps ↗",
      pin: "Provalo",
      hoursTitle: "Todos los días:",
      hours1: "19:30 — 22:30",
      hoursWE: "",
      hours2: "",
      monClosed: "",
      ctaNav: "Llévame a Provalo",
      ctaNavHint: "Abre tu navegador con la ruta ya preparada.",
      ctaWA: "Escríbenos por WhatsApp",
      groupTitle: "¿Sois más de doce?",
      groupBody: "Las mesas de 13 personas en adelante se reservan directamente por teléfono. Llámanos y organizamos los pinchos como más os gusten.",
    },
    footer: {
      claim_a: "Sólo los jueves por la noche.",
      claim_b: "En Provalo Spiedinificio.",
      tagline: "Gourmet-Naïf · Una sección de la carta",
      rights: "Todos los derechos reservados",
    },
    sticky: { eyebrow: "Sólo el jueves", line: "Reserva tu noche", btn: "Reservar" },
    menuIntermezzo: {
      title_a: "Más allá del Gourmet-Naïf, aquí está la",
      title_b: "carta completa.",
      btn: "Carta completa",
    },
    social: {
      followEyebrow: "— Síguenos",
      followTitle_a: "Nuestras",
      followTitle_b: "huellas de cada día.",
      channelEyebrow: "— Nuestro canal WhatsApp",
      channelTitle_a: "Detrás de la",
      channelTitle_b: "brasa.",
      channelJoin: "Únete al canal",
      channelSub: "Avances, novedades y rituales del Lab",
    },
    modal: {
      eyebrow: "— Reserva",
      title_a: "Tu jueves ", title_b: "en Provalo.",
      sub: "Déjanos un contacto: te confirmamos por teléfono.",
      l_name: "Nombre y apellido", ph_name: "Juan Pérez",
      l_phone: "Teléfono", ph_phone: "+34 600 …",
      l_people: "Personas",
      l_thu: "Qué jueves",
      l_note: "Notas (opcional)", ph_note: "¿Algo que debamos saber?",
      err: "Introduce un nombre y un teléfono válidos.",
      genErr: "Algo ha ido mal. Inténtalo de nuevo o usa el botón externo.",
      submit: "Confirmar reserva", submitting: "Enviando…",
      portalHint: "¿Prefieres el sistema oficial?", portalLink: "Abrir el portal de reservas",
      successTitle_a: "Nos vemos el ", successTitle_b: "jueves.",
      successBody: "Hemos recibido tu solicitud. Te contactaremos en breve para confirmar.",
      close: "Cerrar",
    },
  },
  fr: {
    topbar: { thursdayOnly: "Uniquement le jeudi soir", addressHint: "10 min de l'aéroport" },
    hero: {
      eyebrow: "— Gourmet-Naïf · La rubrique du jeudi",
      title: ["Chaque jeudi, chez Provalo,", "quelque chose de différent", "s'ouvre."],
      subtitle_a: "Une rubrique spéciale de la carte, dédiée aux brochettes les plus travaillées, aux créations du ",
      subtitle_b: "Provalo-Lab",
      subtitle_c: " et à tout ce qui naît pour surprendre.",
      micro: "Vous pouvez vivre votre Provalo habituel. Ou vous laisser tenter par quelque chose qui n'existe que le jeudi.",
      ctaReserve: "Réservez votre jeudi",
      ctaDiscover: "Découvrez le Gourmet-Naïf",
      scroll: "Faites défiler",
    },
    intro: {
      eyebrow: "— Le Gourmet-Naïf, c'est quoi",
      title_a: "Pas une soirée à thème.",
      title_b: "Une rubrique",
      title_c: " qui s'allume.",
      p1_a: "Chaque jeudi soir, une rubrique spéciale apparaît dans la carte de Provalo : ",
      p1_b: "Gourmet-Naïf",
      p1_c: ".",
      p2: "Un endroit où cohabitent recherche, braise, idées nouvelles et brochettes hors normes. Pas de menu dégustation imposé. Aucune formalité. Juste le plaisir de découvrir quelque chose de différent, à votre rythme.",
      menuBtn: "Ouvrir la carte complète",
      menuHint: "Le Gourmet-Naïf et tout le reste, dans une seule carte.",
      quote: '"recherche · braise · surprise"',
    },
    manifesto: {
      eyebrow: "— En 22 secondes",
      title_a: "Le ",
      title_b: "Gourmet-Naïf",
      title_c: ", tel que nous le vivons.",
      audioOn: "Activer le son",
      caption: "Vingt-deux secondes. Tout ce que signifie un jeudi.",
    },
    lab: {
      eyebrow: "— Le Provalo-Lab",
      title_a: "Là où les idées",
      title_b: "deviennent brochettes.",
      p1_a: "Le ",
      p1_b: "Provalo-Lab",
      p1_c: " est notre espace de recherche et développement gastronomique.",
      p2: "C'est ici que naissent textures, contrastes, expériences et créations qui demandent des mois d'essais avant d'arriver à table.",
      pull_a: "Pas pour compliquer la cuisine.",
      pull_b: "Mais pour la rendre inoubliable.",
    },
    products: {
      labelPrefix: "Gourmet-Naïf · ",
      attimosphera: {
        name_a: "Attimo", name_b: "sphera", name_c: ".",
        tagline: "Une expérience sensorielle née au Provalo-Lab",
        p1: "Une petite architecture comestible : forme sphérique, contrastes de température, temps suspendu. On s'arrête, on regarde, on mord.",
        p2: "Le fruit de mois d'essais.",
        pull: "Une sphère, plusieurs instants à retenir.",
      },
      picanha: {
        name_a: "Picanha ", name_b: "&", name_c: " Pata Negra.",
        tagline: "Deux viandes nobles. Une seule brochette.",
        p1: "La rencontre entre la coupe brésilienne la plus charnelle et le gras de Pata Negra : lent, profond, doux.",
        p2: "La brochette qui raconte comment deux traditions lointaines peuvent s'enlacer sur la même braise.",
      },
      filofumo: {
        name_a: "Filet de ", name_b: "Fumée", name_c: ".",
        tagline: "Une mini-porchetta réinterprétée en brochette",
        p1: "Enveloppante, aromatique, surprenante. La porchetta quitte l'étal du village et monte sur la brochette, avec un filet de fumée qui reste après la dernière bouchée.",
        p2: "Une tradition qui se remet en jeu. Sans demander la permission.",
      },
      salsiccia: {
        name_a: "Mélange de Saucisse ", name_b: "de Messine", name_c: ".",
        tagline: "La tradition qui continue de surprendre",
        p1: "Deux variantes, deux caractères, une seule origine. La saucisse de Messine racontée en formats et mélanges différents, à partager lentement.",
        p2: "Le morceau le plus convivial du Gourmet-Naïf. Celui qui remplit la table de voix.",
      },
      whisky: {
        name_a: "Sauce au ", name_b: "Whisky", name_c: ".",
        tagline: "Pas une sauce. Un petit coup de théâtre.",
        p1: "Elle arrive à table comme un détail. Elle reste en mémoire comme un tournant.",
        p2: "Chaude, ambrée, légèrement fumée. Elle change le goût de la brochette avant même la fin de la première bouchée.",
        pull: "Une seconde avant, tu savais ce que tu mangeais. Une seconde après, plus du tout.",
        ornament: '"quelque chose de liquide, ambré, qui change tout dès la première bouchée."',
      },
    },
    convivialita: {
      eyebrow: "— Convivialité",
      title_a: "Le meilleur arrive ",
      title_b: "autour de la table.",
      p1: "Le Gourmet-Naïf n'est pas là pour mettre de la distance.",
      p2: "Il est là pour créer des conversations, du partage, de la curiosité — et de petits silences devant quelque chose qu'on n'attendait pas.",
    },
    filosofia: {
      eyebrow: "— La philosophie",
      title_a: "Gourmet,", title_a2: " parce qu'il y a de la recherche.",
      title_b: "Naïf,", title_b2: " parce que ça reste humain.",
      pull_a: "On aime étudier la cuisine.",
      pull_b: "Mais on aime encore plus voir les gens s'amuser en la mangeant.",
      p1: "C'est pour ça que le Gourmet-Naïf ne veut être ni froid, ni compliqué, ni prétentieux. Il veut être découverte, surprise et plaisir partagé.",
    },
    faq: {
      eyebrow: "— Questions directes, réponses sincères",
      title_a: "Avant de réserver,",
      title_b: "quelques doutes ?",
      q1: { q: "Dois-je réserver même si je veux seulement la carte habituelle ?",
        a1: "Oui. Le jeudi est une soirée très demandée, y compris pour celles et ceux qui viennent pour la carte habituelle. Pour éviter toute confusion, nous avons deux parcours de réservation séparés : un pour ceux qui viennent pour le Gourmet-Naïf, un pour ceux qui viennent pour le Provalo classique. Ainsi on sait qui attendre, et vous trouvez votre table prête.",
        a2: "Et si en passant vous voyez défiler une Attimosphera et changez d'avis, il sera toujours temps de la commander à table.",
        cta: "Réserver pour la carte habituelle" },
      q2: { q: "Puis-je commander le Gourmet-Naïf un autre jour de la semaine ?",
        short: "Non.",
        a1: "Le Gourmet-Naïf n'existe que le jeudi soir. C'est un choix — pas une limite. C'est là que nous concentrons la recherche, la mise en place dédiée et les préparations spéciales, pour que chaque jeudi soit vraiment différent.",
        a2: "Les autres jours, tout le Provalo que vous aimez est toujours là. Et c'est déjà beaucoup." },
      q3: { q: "Y a-t-il des options végétariennes dans le Gourmet-Naïf ?",
        a1: "Dans le Gourmet-Naïf lui-même, non : la rubrique est composée de ces créations précises nées au Provalo-Lab, et ce sont celles-là.",
        a2_pre: "Mais le jeudi ", a2_em: "toute la carte Provalo", a2_post: " est aussi active, et l'on y trouve plusieurs brochettes et créations végétariennes : champignons, fromages, légumes, fruits. On peut tout à fait composer une soirée entièrement végétarienne." },
    },
    ctafinal: {
      eyebrow: "— Votre jeudi",
      title_a: "Le jeudi chez Provalo, ",
      title_b: "voilà ce qui arrive.",
      pull_a: "Vous pouvez venir pour les brochettes que vous aimez depuis toujours.",
      pull_b: "Ou découvrir quelque chose qui n'existe que ce soir-là.",
      ctaReserve: "Réservez votre jeudi",
      ctaMenu: "Voir la carte Gourmet-Naïf",
    },
    recensioni: {
      eyebrow: "— Avis authentiques",
      title_a: "Ne nous demandez pas à nous.", title_b: "Demandez", title_c: " à ceux qui étaient à table.",
      desc: "Presque mille avis réels. Une moyenne qui parle d'elle-même. Nous ne choisissons pas ce que vous lisez : tout est là, exactement tel que ça a été écrit.",
      stat1_v: ">", stat1_v_big: "900", stat1_label: "Avis", stat1_sub: "Sur TripAdvisor — tous vérifiés",
      stat2_label: "Moyenne TripAdvisor", stat2_sub: "Moyenne globale 4,7 incluant Google",
      stat3_v: "Top 10%", stat3_label: "Travelers' Choice 2025", stat3_sub: "Parmi les meilleurs au monde, selon les voyageurs",
      stat4_v: "1er", stat4_label: "À Fiumicino", stat4_sub: "Au classement TripAdvisor de la ville",
      ctaTA: "Lire tous les avis sur TripAdvisor",
      ctaCaption: "Les derniers, les plus sincères, les plus durs. Ils sont tous là.",
    },
    navigatore: {
      eyebrow: "— Venez nous voir",
      title_a: "À ", title_b: "dix minutes", title_c: " de l'aéroport de Fiumicino.",
      mapOpen: "Ouvrir dans Google Maps ↗",
      pin: "Provalo",
      hoursTitle: "Tous les jours :",
      hours1: "19h30 — 22h30",
      hoursWE: "",
      hours2: "",
      monClosed: "",
      ctaNav: "Emmène-moi chez Provalo",
      ctaNavHint: "Ouvre votre application de navigation avec l'itinéraire déjà prêt.",
      ctaWA: "Écrivez-nous sur WhatsApp",
      groupTitle: "Vous êtes plus de douze ?",
      groupBody: "Les tablées à partir de 13 personnes se réservent directement par téléphone. Appelez-nous et on organise les brochettes comme vous les aimez.",
    },
    footer: {
      claim_a: "Uniquement le jeudi soir.",
      claim_b: "Chez Provalo Spiedinificio.",
      tagline: "Gourmet-Naïf · Une rubrique de la carte",
      rights: "Tous droits réservés",
    },
    sticky: { eyebrow: "Seulement le jeudi", line: "Réservez votre soirée", btn: "Réserver" },
    menuIntermezzo: {
      title_a: "Au-delà du Gourmet-Naïf, voici la",
      title_b: "carte complète.",
      btn: "Carte complète",
    },
    social: {
      followEyebrow: "— Suivez-nous",
      followTitle_a: "Nos",
      followTitle_b: "traces du quotidien.",
      channelEyebrow: "— Notre canal WhatsApp",
      channelTitle_a: "Derrière la",
      channelTitle_b: "braise.",
      channelJoin: "Rejoindre le canal",
      channelSub: "Avant-premières, nouveautés & rituels du Lab",
    },
    modal: {
      eyebrow: "— Réservation",
      title_a: "Votre jeudi ", title_b: "chez Provalo.",
      sub: "Laissez-nous un contact : nous confirmons par téléphone.",
      l_name: "Nom et prénom", ph_name: "Jean Dupont",
      l_phone: "Téléphone", ph_phone: "+33 6 …",
      l_people: "Personnes",
      l_thu: "Quel jeudi",
      l_note: "Notes (facultatif)", ph_note: "Quelque chose que nous devrions savoir ?",
      err: "Saisissez un nom et un téléphone valides.",
      genErr: "Quelque chose s'est mal passé. Réessayez ou utilisez le bouton externe.",
      submit: "Confirmer la réservation", submitting: "Envoi en cours…",
      portalHint: "Vous préférez le système officiel ?", portalLink: "Ouvrir le portail de réservation",
      successTitle_a: "À ", successTitle_b: "jeudi.",
      successBody: "Nous avons bien reçu votre demande. Nous vous contacterons rapidement pour confirmer.",
      close: "Fermer",
    },
  },
  de: {
    topbar: { thursdayOnly: "Nur am Donnerstagabend", addressHint: "10 Min. vom Flughafen" },
    hero: {
      eyebrow: "— Gourmet-Naïf · Der Donnerstag-Bereich",
      title: ["Jeden Donnerstag öffnet sich", "etwas Anderes", "bei Provalo."],
      subtitle_a: "Ein eigener Bereich der Karte — gewidmet unseren raffiniertesten Spießen, den Kreationen des ",
      subtitle_b: "Provalo-Lab",
      subtitle_c: " und allem, was bei uns aus Lust am Überraschen entsteht.",
      micro: "Du kannst dein gewohntes Provalo erleben. Oder dich auf etwas einlassen, das es nur am Donnerstag gibt.",
      ctaReserve: "Reserviere deinen Donnerstag",
      ctaDiscover: "Entdecke das Gourmet-Naïf",
      scroll: "Scrollen",
    },
    intro: {
      eyebrow: "— Was das Gourmet-Naïf ist",
      title_a: "Kein Themenabend.",
      title_b: "Ein Bereich",
      title_c: ", der sich entzündet.",
      p1_a: "Jeden Donnerstagabend erscheint auf der Provalo-Karte ein besonderer Bereich: ",
      p1_b: "Gourmet-Naïf",
      p1_c: ".",
      p2: "Ein Ort, an dem Forschung, Glut, neue Ideen und ungewöhnliche Spieße zusammenleben. Kein Pflicht-Tasting. Keine Förmlichkeit. Nur die Freude, etwas Anderes zu entdecken — in deinem eigenen Tempo.",
      menuBtn: "Komplette Karte öffnen",
      menuHint: "Gourmet-Naïf und alles andere, in einer einzigen Karte.",
      quote: '"Forschung · Glut · Überraschung"',
    },
    manifesto: {
      eyebrow: "— In 22 Sekunden",
      title_a: "Das ",
      title_b: "Gourmet-Naïf",
      title_c: ", so wie wir es tatsächlich leben.",
      audioOn: "Ton aktivieren",
      caption: "Zweiundzwanzig Sekunden. Alles, was Donnerstag bedeutet.",
    },
    lab: {
      eyebrow: "— Das Provalo-Lab",
      title_a: "Wo aus Ideen",
      title_b: "Spieße werden.",
      p1_a: "Das ",
      p1_b: "Provalo-Lab",
      p1_c: " ist unser Raum für kulinarische Forschung und Entwicklung.",
      p2: "Hier entstehen Texturen, Kontraste, Experimente und Kreationen, die monatelange Versuche brauchen, bevor sie an den Tisch kommen.",
      pull_a: "Nicht, um das Essen komplizierter zu machen.",
      pull_b: "Sondern, um es unvergesslich zu machen.",
    },
    products: {
      labelPrefix: "Gourmet-Naïf · ",
      attimosphera: {
        name_a: "Attimo", name_b: "sphera", name_c: ".",
        tagline: "Ein sinnliches Erlebnis, geboren im Provalo-Lab",
        p1: "Eine kleine essbare Architektur: kugelförmig, Temperaturkontraste, ausgesetzte Zeit. Man hält inne, schaut, beißt zu.",
        p2: "Aus monatelangem Probieren entstanden.",
        pull: "Eine Kugel, mehrere Augenblicke, die bleiben.",
      },
      picanha: {
        name_a: "Picanha ", name_b: "&", name_c: " Pata Negra.",
        tagline: "Zwei edle Fleischsorten. Ein einziger Spieß.",
        p1: "Die Begegnung zwischen dem fleischigsten brasilianischen Cut und dem langsam-süßen Fett des Pata Negra.",
        p2: "Der Spieß, der zeigt, wie zwei entfernte Traditionen sich auf derselben Glut umarmen können.",
      },
      filofumo: {
        name_a: "Faden aus ", name_b: "Rauch", name_c: ".",
        tagline: "Eine Mini-Porchetta, neu gedacht auf dem Spieß",
        p1: "Umhüllend, aromatisch, überraschend. Die Porchetta verlässt den Dorfstand und steigt auf den Spieß — mit einem Hauch von Räucherung, der nach dem letzten Bissen noch bleibt.",
        p2: "Tradition, die sich neu ins Spiel bringt. Ohne um Erlaubnis zu fragen.",
      },
      salsiccia: {
        name_a: "Mix Messiner ", name_b: "Salsiccia", name_c: ".",
        tagline: "Tradition, die weiter überrascht",
        p1: "Zwei Varianten, zwei Charaktere, eine einzige Herkunft. Die Salsiccia aus Messina, erzählt in unterschiedlichen Formaten und Mischungen — zum langsamen Teilen.",
        p2: "Das geselligste Stück des Gourmet-Naïf. Das, was den Tisch mit Stimmen füllt.",
      },
      whisky: {
        name_a: "Whisky-", name_b: "Sauce", name_c: ".",
        tagline: "Keine Sauce. Eine kleine Wendung.",
        p1: "Sie kommt als Detail an den Tisch. Sie bleibt als Wendung in Erinnerung.",
        p2: "Warm, bernsteinfarben, leicht geräuchert. Sie verändert den Geschmack des Spießes, bevor du den ersten Bissen beendet hast.",
        pull: "Eine Sekunde vorher wusstest du, was du isst. Eine Sekunde später nicht mehr.",
        ornament: '"etwas Flüssiges, Bernsteinfarbenes, das beim ersten Bissen alles verändert."',
      },
    },
    convivialita: {
      eyebrow: "— Geselligkeit",
      title_a: "Das Schöne passiert ",
      title_b: "rund um den Tisch.",
      p1: "Das Gourmet-Naïf entsteht nicht, um Distanz zu schaffen.",
      p2: "Es entsteht, um Gespräche, Teilen, Neugier und kleine Stille vor etwas zu wecken, das man nicht erwartet hatte.",
    },
    filosofia: {
      eyebrow: "— Die Philosophie",
      title_a: "Gourmet,", title_a2: " weil dahinter Forschung steckt.",
      title_b: "Naïf,", title_b2: " weil es menschlich bleibt.",
      pull_a: "Wir lieben es, Essen zu studieren.",
      pull_b: "Aber noch lieber sehen wir Menschen Spaß daran haben.",
      p1: "Deshalb will das Gourmet-Naïf nicht kalt, kompliziert oder anmaßend sein. Es will Entdeckung, Überraschung und geteiltes Vergnügen sein.",
    },
    faq: {
      eyebrow: "— Klare Fragen, ehrliche Antworten",
      title_a: "Vor der Reservierung,",
      title_b: "noch Zweifel?",
      q1: { q: "Muss ich auch reservieren, wenn ich nur die normale Karte möchte?",
        a1: "Ja. Der Donnerstag ist ein sehr gefragter Abend — auch für Gäste, die wegen der gewohnten Karte kommen. Um Verwechslungen zu vermeiden, haben wir zwei getrennte Reservierungswege: einen für jene, die für das Gourmet-Naïf kommen, und einen für jene, die für das klassische Provalo kommen. So wissen wir, wen wir erwarten, und ihr findet euren Tisch bereit.",
        a2: "Und wer beim Hinsehen eine vorbeiziehende Attimosphera entdeckt und plötzlich Lust darauf bekommt, kann sie immer noch am Tisch bestellen.",
        cta: "Für die normale Karte reservieren" },
      q2: { q: "Kann ich das Gourmet-Naïf an einem anderen Wochentag bestellen?",
        short: "Nein.",
        a1: "Das Gourmet-Naïf gibt es ausschließlich am Donnerstagabend. Das ist eine Entscheidung — keine Einschränkung. Dort konzentrieren wir die Forschung, die eigene Mise en place und die besonderen Vorbereitungen, damit jeder Donnerstag wirklich anders ist als die übrigen Abende.",
        a2: "An den anderen Tagen ist das ganze Provalo da, das du liebst. Und das ist mehr als genug." },
      q3: { q: "Gibt es vegetarische Optionen im Gourmet-Naïf?",
        a1: "Innerhalb des Gourmet-Naïf nicht: Der Bereich besteht aus genau diesen Kreationen, die im Provalo-Lab entstanden sind — und das sind eben diese.",
        a2_pre: "Donnerstags ist allerdings ", a2_em: "die gesamte Provalo-Karte", a2_post: " ebenfalls aktiv, und darin gibt es zahlreiche vegetarische Spieße und Kreationen: Pilze, Käse, Gemüse, Obst. Ein vollständig vegetarischer Abend lässt sich problemlos zusammenstellen." },
    },
    ctafinal: {
      eyebrow: "— Dein Donnerstag",
      title_a: "Donnerstags bei Provalo ",
      title_b: "passiert genau das.",
      pull_a: "Du kannst wegen der Spieße kommen, die du seit jeher liebst.",
      pull_b: "Oder etwas entdecken, das es nur an diesem Abend gibt.",
      ctaReserve: "Reserviere deinen Donnerstag",
      ctaMenu: "Die Gourmet-Naïf-Karte ansehen",
    },
    recensioni: {
      eyebrow: "— Echte Bewertungen",
      title_a: "Frag nicht uns.", title_b: "Frag", title_c: " die, die am Tisch saßen.",
      desc: "Fast tausend echte Bewertungen. Ein Durchschnitt, der für sich spricht. Wir suchen nicht aus, was du liest: alles ist da, genau so, wie es geschrieben wurde.",
      stat1_v: ">", stat1_v_big: "900", stat1_label: "Bewertungen", stat1_sub: "Auf TripAdvisor — alle verifiziert",
      stat2_label: "TripAdvisor-Schnitt", stat2_sub: "Gesamtschnitt 4,7 inkl. Google",
      stat3_v: "Top 10%", stat3_label: "Travelers' Choice 2025", stat3_sub: "Unter den besten der Welt, laut den Reisenden",
      stat4_v: "1.", stat4_label: "In Fiumicino", stat4_sub: "Im TripAdvisor-Ranking der Stadt",
      ctaTA: "Alle Bewertungen auf TripAdvisor lesen",
      ctaCaption: "Die neuesten, die ehrlichsten, die härtesten. Sie sind alle dort.",
    },
    navigatore: {
      eyebrow: "— Besuche uns",
      title_a: "Nur ", title_b: "zehn Minuten", title_c: " vom Flughafen Fiumicino.",
      mapOpen: "In Google Maps öffnen ↗",
      pin: "Provalo",
      hoursTitle: "Täglich:",
      hours1: "19:30 — 22:30",
      hoursWE: "",
      hours2: "",
      monClosed: "",
      ctaNav: "Bring mich zu Provalo",
      ctaNavHint: "Öffnet deine bevorzugte Navi-App mit der Route.",
      ctaWA: "Schreib uns auf WhatsApp",
      groupTitle: "Seid ihr mehr als zwölf?",
      groupBody: "Tische ab 13 Personen werden direkt telefonisch reserviert. Ruf uns an, und wir richten die Spieße so ein, wie ihr sie gern habt.",
    },
    footer: {
      claim_a: "Nur am Donnerstagabend.",
      claim_b: "Bei Provalo Spiedinificio.",
      tagline: "Gourmet-Naïf · Ein Bereich der Karte",
      rights: "Alle Rechte vorbehalten",
    },
    sticky: { eyebrow: "Nur am Donnerstag", line: "Reserviere deinen Abend", btn: "Reservieren" },
    menuIntermezzo: {
      title_a: "Neben dem Gourmet-Naïf hier die",
      title_b: "komplette Karte.",
      btn: "Komplette Karte",
    },
    social: {
      followEyebrow: "— Folge uns",
      followTitle_a: "Unsere",
      followTitle_b: "Spuren des Alltags.",
      channelEyebrow: "— Unser WhatsApp-Kanal",
      channelTitle_a: "Hinter der",
      channelTitle_b: "Glut.",
      channelJoin: "Dem Kanal beitreten",
      channelSub: "Previews, Neuigkeiten & Rituale aus dem Lab",
    },
    modal: {
      eyebrow: "— Reservierung",
      title_a: "Dein Donnerstag ", title_b: "bei Provalo.",
      sub: "Hinterlasse uns einen Kontakt — wir bestätigen telefonisch.",
      l_name: "Vor- und Nachname", ph_name: "Max Mustermann",
      l_phone: "Telefon", ph_phone: "+49 …",
      l_people: "Personen",
      l_thu: "Welcher Donnerstag",
      l_note: "Anmerkungen (optional)", ph_note: "Etwas, das wir wissen sollten?",
      err: "Bitte gib einen gültigen Namen und Telefon an.",
      genErr: "Etwas ist schiefgegangen. Bitte erneut versuchen oder den externen Button verwenden.",
      submit: "Reservierung bestätigen", submitting: "Wird gesendet…",
      portalHint: "Lieber das offizielle System?", portalLink: "Reservierungsportal öffnen",
      successTitle_a: "Bis ", successTitle_b: "Donnerstag.",
      successBody: "Wir haben deine Anfrage erhalten. Wir melden uns zur Bestätigung in Kürze.",
      close: "Schließen",
    },
  },
};

export const LANGUAGES = [
  { code: "it", flag: "🇮🇹", label: "Italiano" },
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
];
